import { useMemo } from 'react'
import { defineMessage, useIntl } from 'react-intl'
import Text from 'components/shared/Text'
import CheckedList, {
    CheckedIconVariantType,
} from 'components/shared/CheckedList'
import { CardEditionType } from 'store/api-slice/types'

interface UnlimitedAdvantagesProps {
    cardEdition: CardEditionType
    isAlt?: boolean
    iconVariant?: CheckedIconVariantType
}

const UnlimitedAdvantages = ({
    cardEdition,
    isAlt,
    iconVariant = 'blue',
}: UnlimitedAdvantagesProps) => {
    const { formatMessage } = useIntl()

    const advantagesBlue = useMemo(
        () => [
            defineMessage({
                id: 'annual.renew.advantages_modal_1y_item_01',
                defaultMessage:
                    'Karta Unlimited <strong>taniej o 10% od ceny regularnej</strong>',
            }),
            defineMessage({
                id: 'annual.renew.advantages_modal_1y_item_02',
                defaultMessage:
                    '<strong>25% zniżki</strong> do strefy Wellness & SPA <break></break><disclaimer>(przez cały okres ważności nowej karty)</disclaimer>',
            }),
            defineMessage({
                id: 'annual.renew.advantages_modal_1y_item_03',
                defaultMessage:
                    '<strong>15% zniżki</strong> na produkty w sklepach i restauracjach parku <break></break><disclaimer>(przez cały okres ważności nowej karty)</disclaimer>',
            }),
        ],
        []
    )
    const advantagesBlueAlt = useMemo(
        () => [
            defineMessage({
                id: 'annual.renew.advantages_modal_1y_item_01_alt',
                defaultMessage:
                    'Karta Unlimited <strong>taniej o 10% od ceny regularnej</strong>',
            }),
            ...advantagesBlue.slice(1),
        ],
        []
    )
    const advantagesRed = useMemo(
        () => [
            defineMessage({
                id: 'annual.renew.advantages_modal_2y_item_01',
                defaultMessage:
                    'Karta Unlimited <strong>taniej o 20% od ceny regularnej</strong>',
            }),
            defineMessage({
                id: 'annual.renew.advantages_modal_2y_item_02',
                defaultMessage:
                    '<strong>35% zniżki</strong> do strefy Wellness & SPA <break></break><disclaimer>(przez cały okres ważności nowej karty)</disclaimer>',
            }),
            defineMessage({
                id: 'annual.renew.advantages_modal_2y_item_03',
                defaultMessage:
                    '<strong>20% zniżki</strong> na produkty w sklepach i restauracjach parku<break></break><disclaimer>(przez cały okres ważności nowej karty)</disclaimer>',
            }),
        ],
        []
    )
    const advantagesRedAlt = useMemo(
        () => [
            defineMessage({
                id: 'annual.renew.advantages_modal_2y_item_01_alt',
                defaultMessage:
                    'Karta Unlimited <strong>taniej o 10% od ceny regularnej</strong>',
            }),
            ...advantagesRed.slice(1),
        ],
        []
    )
    const advantages = useMemo(() => {
        switch (cardEdition) {
            case 'blue':
                return isAlt ? advantagesBlueAlt : advantagesBlue
            case 'red':
                return isAlt ? advantagesRedAlt : advantagesRed
            default:
                return []
        }
        return []
    }, [cardEdition])

    const advantagesTransformations = useMemo(
        () => ({
            strong: (chunks: string[]) => (
                <Text variant="bodyStrong" color="primary_500" as="strong">
                    {chunks}
                </Text>
            ),
            disclaimer: (chunks: string[]) => (
                <Text variant="body" color="grayscale_800">
                    {chunks}
                </Text>
            ),
            break: () => <br />,
        }),
        []
    )

    return (
        <CheckedList iconVariant={iconVariant}>
            {advantages.map((advantage, index) => (
                <Text
                    variant="body"
                    color="grayscale_900"
                    key={`advantage1y${index}`}
                >
                    {formatMessage(advantage, advantagesTransformations)}
                </Text>
            ))}
        </CheckedList>
    )
}

export default UnlimitedAdvantages
